import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import {
  assertIsASelectItem,
  assertIsNumberAndIsGreaterThanZero,
  type ISelectItem,
} from '~/types/models'

export enum CompanyMSServicesStatusIds {
  IN_REVIEW = 1,
  READY_FOR_CONTRACT = 2,
  ASSIGNED = 3,
  ACTIVE = 4,
  SUSPENDED = 5,
  DISCONNECTED = 6,
  REACTIVATED = 7,
}

export function isAnyOpenCompanyMSServiceStatus(status: ISelectItem) {
  assertIsASelectItem(isAnyOpenCompanyMSServiceStatus.name, status)
  assertIsNumberAndIsGreaterThanZero(status.id)
  return [
    CompanyMSServicesStatusIds.IN_REVIEW,
    CompanyMSServicesStatusIds.READY_FOR_CONTRACT,
  ].includes(status.id)
}

export function getCompanyMSServicesStatii(): ISelectItem[] {
  return [
    {
      id: CompanyMSServicesStatusIds.IN_REVIEW,
      label: 'In Review',
      disabled: false,
    },
    {
      id: CompanyMSServicesStatusIds.READY_FOR_CONTRACT,
      label: 'Ready for Contract',
      disabled: false,
    },
    {
      id: CompanyMSServicesStatusIds.ASSIGNED,
      label: 'Assigned',
      disabled: true,
    },
    {
      id: CompanyMSServicesStatusIds.ACTIVE,
      label: 'ACTIVE',
      disabled: true,
    },
    {
      id: CompanyMSServicesStatusIds.SUSPENDED,
      label: 'Suspended',
      disabled: true,
    },
    {
      id: CompanyMSServicesStatusIds.DISCONNECTED,
      label: 'DISCONNECTED',
      disabled: true,
    },
    {
      id: CompanyMSServicesStatusIds.REACTIVATED,
      label: 'ACTIVE*',
      disabled: true,
    },
  ]
}

export const getCompanyMSServiceStatusByLabel = getItemByLabelFactory(
  getCompanyMSServicesStatii
)
export const getCompanyMSServiceStatusById = getItemByIdFactory(
  getCompanyMSServicesStatii
)
